( function ( _s ) {
	_s.fn.splideInit = function () {
		return this.each( el => {
			const _self = _s( el );

			let splideInstance = new Splide( el );

			const _splideArrows = _self.find( '.splide__arrows' );
			const _splideTrack = _self.find( '.splide__track' );

			const setPagination = () => {
				// Execute shave for card
				const _cards = _self.find( '.card' );
				_cards.cardInit();

				_self.removeClass( 'has-pagination' );
				const pages = _self.find( '.splide__pagination li' );
				const pageCount = pages ? pages.length : 0;
				// If pagination not available
				if ( ! pageCount ) {
					return;
				}

				pages.each( ( page, index ) => {
					if ( index >= pageCount - 3 && index < pageCount - 1 ) {
						_s( page ).addClass( 'hidden' );
					}
				} );

				_self.toggleClass(
					'has-pagination',
					_self.find( '.splide__pagination' ).outerHeight()
				);
			};

			const arrowsPosition = () => {
				if ( _splideArrows.length ) {
					const splideTrackHeight = _splideTrack.outerHeight();

					_splideArrows.css( 'top', `${ splideTrackHeight / 2 }px` );
				}

				_self.toggleClass( 'has-arrows', _self.find( '.splide__arrows' ).outerHeight() );
			};

			// Add class to hide pagination dots
			// Update arrows position
			splideInstance.on( 'ready', () => {
				setTimeout( () => {
					setPagination();
					arrowsPosition();
				}, 100 );
			} );

			// Add class to hide pagination dots
			_s( window ).on(
				'resize',
				window.debounce( e => {
					setTimeout( () => {
						setPagination();
						arrowsPosition();
					}, 100 );
				}, 100 )
			);

			// Update arrows position
			_s( window ).on( 'resize', () => {
				arrowsPosition();
			} );

			splideInstance.mount( window.splide?.Extensions ?? {} );

			const config = JSON.parse( _self.attr( 'data-splide' ) || '{}' );

			if ( config.auto_resize_height ) {
				_s.fn.frSplideResizeHeightOfSlider( splideInstance );
			}

			//Solves weird bug when the carousel is of type loop and you try to adjust the
			//width of the browser: the slides don't resize. This solves it.
			if ( config.refresh_on_resize ) {
				_s( window ).on(
					'resize',
					window.debounce( e => {
						splideInstance.refresh();
					}, 100 )
				);
			}

			if ( config.emit_events && Array.isArray( config.emit_events ) ) {
				config.emit_events.forEach( evName => {
					splideInstance.on( evName, ( a, b, c ) => {
						_self.trigger( `fr-splide-${ evName }`, {
							newIndex: a,
							prevIndex: b,
							destIndex: c,
						} );
					} );
				} );
			}

			/**
			 * if the option is true, then we keep track of the instance on the window object for reference
			 * on other functions. The ID attribute is required for this to work
			 */
			if ( config.make_instance_global && _self.attr( 'id' ).length ) {
				if ( ! window.splideInstances ) {
					window.splideInstances = {};
				}

				window.splideInstances[ _self.attr( 'id' ) ] = splideInstance;
			}
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '[splide-init]' );
		if ( _elements.el.length ) {
			window
				.fetchInject(
					[
						'https://cdn.jsdelivr.net/npm/@splidejs/splide/dist/js/splide.min.js',
						_elements.filter( '[splide-autoscroll]' ).length
							? 'https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/dist/js/splide-extension-auto-scroll.min.js'
							: false,
					].filter( url => url.length > 0 )
				)
				.then( () => {
					_elements.splideInit();
				} );
		}
	} );
} )( window._s );
